import { type RouteRecordRaw } from 'vue-router'

const rfqsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/purchasing/rfqs',
    name: 'rfqs.index',
    component: () => import('@/modules/purchasing/rfqs/views/RfqsIndex.vue'),
    meta: {
      pageTitle: 'Requests for Quotation',
      breadcrumbs: ['Requests for Quotation']
    }
  },
  {
    path: '/purchasing/rfqs/create',
    name: 'rfqs.create',
    component: () => import('@/modules/purchasing/rfqs/views/RfqCreate.vue'),
    meta: {
      pageTitle: 'Create Request for Quotation',
      breadcrumbs: ['Requests for Quotation', 'Create']
    }
  },
  {
    path: '/purchasing/rfqs/:id',
    name: 'rfqs.show',
    component: () => import('@/modules/purchasing/rfqs/views/RfqsShow.vue'),
    meta: {
      pageTitle: 'Request for Quotation',
      breadcrumbs: ['Requests for Quotation']
    }
  },
  {
    path: '/purchasing/rfqs/:id/create-purchase-order',
    name: 'rfqs.create-purchase-order',
    component: () => import('@/modules/purchasing/rfqs/views/RfqCreatePurchaseOrder.vue'),
    meta: {
      pageTitle: 'Create Purchase Order from Request for Quotation',
      breadcrumbs: ['Requests for Quotation', 'Create Purchase Order']
    }
  },
  {
    path: '/purchasing/quotations/:id/create-purchase-order',
    name: 'quotations.create-purchase-order',
    component: () =>
      import('@/modules/purchasing/quotations/views/QuotationCreatePurchaseOrder.vue'),
    meta: {
      pageTitle: 'Create Purchase Order from Quotation',
      breadcrumbs: ['Quotations', 'Create Purchase Order']
    }
  }
]

export default rfqsRoutes
